// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__5ihkg","respo":"style_respo__erJry","container":"style_container__OZBmX","table":"style_table__qEE3E","detail":"style_detail__z8MhJ"};